// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/static/style/mixins.scss
// module id = 1426
// module chunks = 733